import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import { createComponentVNode } from "inferno";
import { Component } from 'inferno';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'inferno-bootstrap';

var SectionSelect = /*#__PURE__*/function (_Component) {
  _inherits(SectionSelect, _Component);

  function SectionSelect(props) {
    var _this;

    _classCallCheck(this, SectionSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SectionSelect).call(this, props));
    _this.state = {
      dropdownOpen: false
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    _this.didSelect = _this.didSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SectionSelect, [{
    key: "_activeTag",
    value: function _activeTag(_ref, state, _ref2) {
      var _ref$tags = _ref.tags,
          tags = _ref$tags === void 0 ? [] : _ref$tags;
      var _ref2$activeSectionTa = _ref2.activeSectionTags,
          activeSectionTags = _ref2$activeSectionTa === void 0 ? [] : _ref2$activeSectionTa;
      var outp = tags.find(function (t) {
        return Array.isArray(activeSectionTags) ? activeSectionTags.includes(t[1]) : false;
      });
      return Array.isArray(outp) ? outp[0] : outp;
    }
  }, {
    key: "didSelect",
    value: function didSelect(val) {
      var tag = val || this._activeTag();

      this.context.editor.toggleSection(tag);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        dropdownOpen: !this.state.dropdownOpen
      });
    }
  }, {
    key: "render",
    value: function render(_ref3) {
      var _this2 = this;

      var _ref3$tags = _ref3.tags,
          tags = _ref3$tags === void 0 ? [] : _ref3$tags;
      return createComponentVNode(2, ButtonDropdown, {
        "className": this.props.className,
        "isOpen": this.state.dropdownOpen,
        "onChange": this.didSelect,
        "toggle": this.toggle,
        children: [createComponentVNode(2, DropdownToggle, {
          "caret": true,
          children: this._activeTag.apply(this, arguments) || this.props.title || 'Select...'
        }), createComponentVNode(2, DropdownMenu, {
          children: tags.map(function (t) {
            return createComponentVNode(2, DropdownItem, {
              "onClick": function onClick() {
                return _this2.didSelect(t[1]);
              },
              children: t[0]
            });
          })
        })]
      });
    }
  }]);

  return SectionSelect;
}(Component);
/*
const SectionSelect =  => {

  const onChange = (event) => {
    const tag = event.target.value || activeTag()
    editor.toggleSection(tag)
  }

  return (
    <select value={activeTag() || ""} onChange={onChange} {...props}>
      <option value=""></option>
      { tags.map((t) => <option value={t} key={t}>{t.toUpperCase()}</option>) }
    </select>
  )
}
*/

/*
SectionSelect.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.oneOf(['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'aside'])).isRequired
}

SectionSelect.contextTypes = {
  editor: PropTypes.object,
  activeSectionTags: PropTypes.array
}
*/


export default SectionSelect;